import React from 'react';
interface TopBannerProps {
  onClick: () => void;
}
export const TopBanner: React.FC<TopBannerProps> = ({
  onClick
}) => {
  return;
};